import { useEffect, useState } from 'react';

const useCounterInTime = (duration: number, maxCount: number) => {
  const [availableCount, setAvailableCount] = useState<number>(0);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | undefined = undefined;
    clearTimeout(timeoutId);
    if (availableCount === 0) return;
    timeoutId = setTimeout(() => {
      setAvailableCount(0);
    }, duration / maxCount);
    return () => clearTimeout(timeoutId);
  }, [availableCount]);

  const count = () => {
    setAvailableCount((prev: number) => {
      return prev + 1;
    });
    return {
      avaliable: availableCount < maxCount - 1,
    };
  };

  return {
    count,
  };
};

export default useCounterInTime;
